export const addPdf = 'Dodaj';
